/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Script_Name_PlaceholderInputs */

const en_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untitled.xml`)
};

const fr_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untitled.xml`)
};

const de_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untitled.xml`)
};

const it_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`senza titolo.xml`)
};

const ru_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untitled.xml`)
};

const es_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sin título.xml`)
};

const zh_cn2_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untitled.xml`)
};

const ja_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無題.xml`)
};

const hi_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षकहीन.एक्सएमएल`)
};

const pt_pt2_image_export_script_name_placeholder = /** @type {(inputs: Image_Export_Script_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untitled.xml`)
};

/**
* | output |
* | --- |
* | "untitled.xml" |
*
* @param {Image_Export_Script_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_script_name_placeholder = /** @type {((inputs?: Image_Export_Script_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Script_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_script_name_placeholder(inputs)
	if (locale === "de") return de_image_export_script_name_placeholder(inputs)
	if (locale === "it") return it_image_export_script_name_placeholder(inputs)
	if (locale === "ru") return ru_image_export_script_name_placeholder(inputs)
	if (locale === "es") return es_image_export_script_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_script_name_placeholder(inputs)
	if (locale === "ja") return ja_image_export_script_name_placeholder(inputs)
	if (locale === "hi") return hi_image_export_script_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_script_name_placeholder(inputs)
	return en_image_export_script_name_placeholder(inputs)
});